/*
 * dp-overlay.js — Swatch badges & out-of-stock overlays engine.
 * Self-contained, independent of the dual-price code. Loaded by the
 * "Swatch badges & overlays" section, which emits one
 * <script class="dp-rule">{…}</script> per block (the single source of config).
 *
 * Applies each rule to the matching Variant Swatch King option, re-applies when
 * the swatches rebuild (material change), and — importantly — rebuilds live in the
 * Theme editor when you edit a block (Shopify section/block events), so changes
 * show immediately without toggling anything.
 */
(function () {
  'use strict';
  var VALID = ['crown', 'pulse', 'ribbon', 'tag', 'glow', 'stamp', 'banner', 'veil', 'stripes'];

  function collectRules() {
    var rules = [];
    [].forEach.call(document.querySelectorAll('script.dp-rule'), function (s) {
      try { var r = JSON.parse(s.textContent); if (r && r.kind) rules.push(r); } catch (e) {}
    });
    return rules;
  }
  function isUnavailable(li) {
    var b = li.querySelector('.swatch-button, .swatch-custom-image');
    var c = (li.className || '') + ' ' + (b ? b.className : '');
    return /sold-?out|unavailable|not-?available|disabled/i.test(c) || li.getAttribute('aria-disabled') === 'true';
  }
  function applyBadgeRule(rule) {
    if (!rule.text || !rule.match) return;
    var m = String(rule.match).toLowerCase();
    var style = rule.style || 'crown'; if (VALID.indexOf(style) < 0) style = 'crown';
    var pos = rule.pos || 'top-right';
    [].forEach.call(document.querySelectorAll('.swatch-view-item'), function (li) {
      var v = (li.getAttribute('orig-value') || li.getAttribute('aria-label') || '').toLowerCase();
      if (v.indexOf(m) === -1 || li.querySelector('.dp-swatch-badge')) return;
      if (getComputedStyle(li).position === 'static') li.style.position = 'relative';
      li.classList.add('has-dp-badge');
      var outer = document.createElement('span');
      outer.className = 'dp-swatch-badge dp-pos--' + pos + (rule.diagonal ? ' dp-diag' : '');
      if (rule.id) outer.setAttribute('data-dp-rule', rule.id);
      var inner = document.createElement('span');
      inner.className = 'dp-badge-inner dp-badge--' + style;
      inner.textContent = rule.text;
      outer.appendChild(inner); li.appendChild(outer);
    });
  }
  function applyOosRule(rule) {
    if (!rule.text) return;
    var style = rule.style || 'veil';
    var m = rule.match ? String(rule.match).toLowerCase() : null;
    var cls = 'dp-oos dp-oos--' + style + ' dp-va--' + (rule.valign || 'center') + ' dp-ha--' + (rule.halign || 'center') + (rule.diagonal ? ' dp-diag' : '');
    [].forEach.call(document.querySelectorAll('.swatch-view-item'), function (li) {
      if (li.querySelector('.dp-oos') || !isUnavailable(li)) return;
      if (m) { var v = (li.getAttribute('orig-value') || '').toLowerCase(); if (v.indexOf(m) === -1) return; }
      if (getComputedStyle(li).position === 'static') li.style.position = 'relative';
      li.classList.add('dp-oos-host');
      var outer = document.createElement('span'); outer.className = cls;
      if (rule.id) outer.setAttribute('data-dp-rule', rule.id);
      var inner = document.createElement('span'); inner.className = 'dp-oos-inner'; inner.textContent = rule.text;
      outer.appendChild(inner); li.appendChild(outer);
    });
  }
  function removeAll() {
    [].forEach.call(document.querySelectorAll('.dp-swatch-badge, .dp-oos'), function (e) { e.remove(); });
    [].forEach.call(document.querySelectorAll('.has-dp-badge, .dp-oos-host'), function (li) {
      li.classList.remove('has-dp-badge'); li.classList.remove('dp-oos-host');
    });
  }
  function applyRules() {
    var rules = collectRules();
    var hasOos = rules.some(function (r) { return r.kind === 'oos'; });
    [].forEach.call(document.querySelectorAll('.swatch-view-item.dp-oos-host'), function (li) {
      if (!hasOos || !isUnavailable(li)) { var e = li.querySelector('.dp-oos'); if (e) e.remove(); li.classList.remove('dp-oos-host'); }
    });
    rules.forEach(function (r) { if (r.kind === 'badge') applyBadgeRule(r); else if (r.kind === 'oos') applyOosRule(r); });
  }
  function rebuild() { removeAll(); applyRules(); }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(applyRules, 120); }
  function connect() {
    var root = document.querySelector('variant-selects') || document.querySelector('.swatches') || document.querySelector('#MainContent') || document.body;
    try { new MutationObserver(schedule).observe(root.parentNode || root, { childList: true, subtree: true }); } catch (e) {}
  }
  function init() {
    applyRules();
    connect();
    // Theme-editor: rebuild instantly when a block/section is edited, added, moved.
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(rebuild, 60); });
    });
    setTimeout(applyRules, 600);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
